


  
  

  var faAngleLeft = {
    prefix: 'fass',
    iconName: 'angle-left',
    icon: [
      320,
      512,
      [8249],
      'f104',
      
      'M19 256l22.6 22.6 160 160 22.6 22.6 45.3-45.3-160-160 137.4-137.4 22.6-22.6-45.3-45.3-22.6 22.6-160 160-22.6 22.6z'
      
    ]
  };

  

  
  

  var faAngleRight = {
    prefix: 'fass',
    iconName: 'angle-right',
    icon: [
      320,
      512,
      [8250],
      'f105',
      
      'M301.5 256L278.9 278.6 118.9 438.6 96.3 461.3 51 416 73.6 393.4 211 256 73.6 118.6 51 96 96.3 50.7 118.9 73.4 278.9 233.4 301.5 256z'
      
    ]
  };

  

  
  

  var faArrowRightArrowLeft = {
    prefix: 'fass',
    iconName: 'arrow-right-arrow-left',
    icon: [
      576,
      512,
      [8644,"exchange"],
      'f0ec',
      
      'M534.9 150.6c-76.2 76.2-115.8 115.8-118.6 118.6L371 224c12-12 33.3-33.3 64-64l-402.7 0 0-64 402.7 0c-30.7-30.7-52-52-64-64l45.3-45.3c2.9 2.9 42.4 42.4 118.6 118.6l22.6 22.6-22.6 22.6zM41.6 406.6L19 384c2.9-2.9 42.4-42.4 118.6-118.6l22.6-22.6 45.3 45.3-64 64 402.7 0 0 64-402.7 0 64 64-45.3 45.3c-2.9-2.9-42.4-42.4-118.6-118.6z'
      
    ]
  };

  
    var faExchange = faArrowRightArrowLeft;
  

  
  

  var faCheck = {
    prefix: 'fass',
    iconName: 'check',
    icon: [
      512,
      512,
      [10003,10004],
      'f00c',
      
      'M493 88.9l-18.8 25.9-256 352-22 30.3c-.7-.7-52.2-52.2-154.5-154.5L19 320 64.3 274.7c1.9 1.9 43.3 43.3 124.1 124.1l234-321.7 18.8-25.9 51.8 37.6z'
      
    ]
  };

  

  
  

  var faChevronDown = {
    prefix: 'fass',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      'M256.3 429.3l214.6-214.6 22.6-22.6-45.3-45.3-22.6 22.6-169.4 169.4-169.4-169.4-22.6-22.6-45.3 45.3 22.6 22.6 192 192 22.6 22.6z'
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fass',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      'M3 256l22.6 22.6 192 192 22.6 22.6 45.3-45.3-22.6-22.6-169.4-169.4 169.4-169.4 22.6-22.6-45.3-45.3-22.6 22.6-192 192-22.6 22.6z'
      
    ]
  };

  

  
  

  var faChevronRight = {
    prefix: 'fass',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      'M317.5 256L294.9 278.6 102.9 470.6 80.3 493.3 35 448 57.6 425.4 227 256 57.6 86.6 35 64 80.3 18.7 102.9 41.4 294.9 233.4 317.5 256z'
      
    ]
  };

  

  
  

  var faChevronUp = {
    prefix: 'fass',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      'M256.3 82.7l22.6 22.6 214.6 214.6-45.3 45.3-22.6-22.6-169.4-169.4-169.4 169.4-22.6 22.6-45.3-45.3 22.6-22.6 192-192 22.6-22.6z'
      
    ]
  };

  

  
  

  var faChevronsLeft = {
    prefix: 'fass',
    iconName: 'chevrons-left',
    icon: [
      512,
      512,
      ["chevron-double-left"],
      'f323',
      
      'M41.6 233.4l-22.6 22.6 22.6 22.6 192 192 22.6 22.6 45.3-45.3-22.6-22.6-169.4-169.4 169.4-169.4 22.6-22.6-45.3-45.3-22.6 22.6-192 192zm192 0l-22.6 22.6 22.6 22.6 192 192 22.6 22.6 45.3-45.3-22.6-22.6-169.4-169.4 169.4-169.4 22.6-22.6-45.3-45.3-22.6 22.6-192 192z'
      
    ]
  };

  
    var faChevronDoubleLeft = faChevronsLeft;
  

  
  

  var faChevronsRight = {
    prefix: 'fass',
    iconName: 'chevrons-right',
    icon: [
      512,
      512,
      ["chevron-double-right"],
      'f324',
      
      'M278.9 278.6L301.5 256 278.9 233.4 86.9 41.4 64.3 18.7 19 64 41.6 86.6 211 256 41.6 425.4 19 448 64.3 493.3 86.9 470.6 278.9 278.6zm192 0l22.6-22.6-22.6-22.6-192-192-22.6-22.6-45.3 45.3 22.6 22.6 169.4 169.4-169.4 169.4-22.6 22.6 45.3 45.3 22.6-22.6 192-192z'
      
    ]
  };

  
    var faChevronDoubleRight = faChevronsRight;
  

  
  

  var faCircleCheck = {
    prefix: 'fass',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      'M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm97.1-319.6l-12.7 20.4-80 128-7 11.3-25.3 0-7.2-9.6c-37.6-50.1-58.4-77.9-62.4-83.2l38.4-28.8c7.5 10 21.3 28.4 41.4 55.2 49.1-78.5 73.8-118.1 74.2-118.7l40.7 25.4z'
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faCircleExclamation = {
    prefix: 'fass',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      'M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-368l0 144-48 0 0-144 48 0zM232 376l0-48 48 0 0 48-48 0z'
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faCircleQuestion = {
    prefix: 'fass',
    iconName: 'circle-question',
    icon: [
      512,
      512,
      [62108,"question-circle"],
      'f059',
      
      'M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-336c-17.7 0-32 14.3-32 32l-48 0c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.1-20.5 57.5-38.2 70-6.3 4.4-12.5 7.8-17.8 10.4l0 21.9-48 0 0-56.7c1.4-.4 2.7-.7 4.1-1.1 12.2-3.2 23.3-6.1 34.1-13.7 10.4-7.3 17.8-16.9 17.8-30.8 0-17.7-14.3-32-32-32zM232 344l48 0 0 48-48 0 0-48z'
      
    ]
  };

  
    var faQuestionCircle = faCircleQuestion;
  

  
  

  var faClock = {
    prefix: 'fass',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339,"clock-four"],
      'f017',
      
      'M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 148.8 10.7 7.1 96 64 20 13.3 26.6-39.9c-2.4-1.6-37.5-25-105.3-70.2l0-147.2-48 0 0 24z'
      
    ]
  };

  
    var faClockFour = faClock;
  

  
  

  var faCodeSimple = {
    prefix: 'fass',
    iconName: 'code-simple',
    icon: [
      640,
      512,
      [],
      'e13d',
      
      'M246.9 118.6l22.6-22.6-45.3-45.3-22.6 22.6-160 160-22.6 22.6 22.6 22.6 160 160 22.6 22.6 45.3-45.3-22.6-22.6-137.4-137.4 137.4-137.4zm146.7 0l137.4 137.4-160 160 45.3 45.3 205.3-205.3-22.6-22.6-160-160-22.6-22.6-45.3 45.3 22.6 22.6z'
      
    ]
  };

  

  
  

  var faCopy = {
    prefix: 'fass',
    iconName: 'copy',
    icon: [
      448,
      512,
      [],
      'f0c5',
      
      'M352 0l-224 0 0 384 320 0 0-288-96-96zM64 128l-64 0 0 384 320 0 0-80-64 0 0 16-192 0 0-256 16 0 0-64-16 0z'
      
    ]
  };

  

  
  

  var faCrosshairs = {
    prefix: 'fass',
    iconName: 'crosshairs',
    icon: [
      576,
      512,
      [],
      'f05b',
      
      'M320-16l0 50.3c98.1 14 175.7 91.6 189.7 189.7l50.3 0 0 64-50.3 0c-14 98.1-91.6 175.7-189.7 189.7l0 50.3-64 0 0-50.3C157.9 463.7 80.3 386.1 66.3 288l-50.3 0 0-64 50.3 0C80.3 125.9 157.9 48.3 256 34.3l0-50.3 64 0zM131.2 288c12.7 62.7 62.1 112.1 124.8 124.8l0-44.8 64 0 0 44.8c62.7-12.7 112.1-62.1 124.8-124.8l-44.8 0 0-64 44.8 0C432.1 161.3 382.7 111.9 320 99.2l0 44.8-64 0 0-44.8C193.3 111.9 143.9 161.3 131.2 224l44.8 0 0 64-44.8 0zM288 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faDash = {
    prefix: 'fass',
    iconName: 'dash',
    icon: [
      512,
      512,
      ["minus-large"],
      'e404',
      
      'M0 224l512 0 0 64-512 0 0-64z'
      
    ]
  };

  
    var faMinusLarge = faDash;
  

  
  

  var faImageLandscape = {
    prefix: 'fass',
    iconName: 'image-landscape',
    icon: [
      576,
      512,
      ["landscape"],
      'e1b5',
      
      'M576 64l-576 0 0 384 576 0 0-384zM96 384L208 256 251.1 305.2 336 192 480 384 96 384zm32-232a40 40 0 1 1 0 80 40 40 0 1 1 0-80z'
      
    ]
  };

  
    var faLandscape = faImageLandscape;
  

  
  

  var faMinus = {
    prefix: 'fass',
    iconName: 'minus',
    icon: [
      448,
      512,
      [8211,8722,10134,"subtract"],
      'f068',
      
      'M0 224l448 0 0 64-448 0 0-64z'
      
    ]
  };

  
    var faSubtract = faMinus;
  

  
  

  var faPlay = {
    prefix: 'fass',
    iconName: 'play',
    icon: [
      512,
      512,
      [9654],
      'f04b',
      
      'M64 16L64 496 496 256 64 16z'
      
    ]
  };

  

  
  

  var faPlus = {
    prefix: 'fass',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      'M256 64l0-32-64 0 0 192-192 0 0 64 192 0 0 192 64 0 0-192 192 0 0-64-192 0 0-160z'
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faRectangleList = {
    prefix: 'fass',
    iconName: 'rectangle-list',
    icon: [
      512,
      512,
      ["list-alt"],
      'f022',
      
      'M512 64l-512 0 0 384 512 0 0-384zM160 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm120-56l168 0 0 48-192 0 0-48 24 0zm0 128l168 0 0 48-192 0 0-48 24 0z'
      
    ]
  };

  
    var faListAlt = faRectangleList;
  

  
  

  var faRotate = {
    prefix: 'fass',
    iconName: 'rotate',
    icon: [
      512,
      512,
      [128260,"sync-alt"],
      'f2f1',
      
      'M512-8L433 71C332.7-25 173.6-23.7 75 75 25 125 0 190.5 0 256l64 0c0-49.2 18.7-98.3 56.2-135.8 73.6-73.6 192.2-75 267.5-3.9L312 192 512 192 512-8zM124.3 395.7L200 320 0 320 0 520 79 441c100.3 96 259.4 94.7 358-4 50-50 75-115.6 75-181l-64 0c0 49.2-18.7 98.3-56.2 135.8-73.6 73.6-192.2 75-267.5 3.9z'
      
    ]
  };

  
    var faSyncAlt = faRotate;
  

  
  

  var faRotateLeft = {
    prefix: 'fass',
    iconName: 'rotate-left',
    icon: [
      512,
      512,
      ["rotate-back","rotate-backward","undo-alt"],
      'f2ea',
      
      'M0 192L0-8 79 71C128.5 23.7 192.3 0 256 0 395.4 0 512.4 116.1 512 256.1 512 397.4 397.4 512 256 512 155.9 512 69.2 454.5 27.2 370.9l57.2-28.8C116 405 181 448 256 448 362 448 448 362 448 256l0-.1c.4-104.2-87.7-191.9-192-191.9-47.4 0-94.8 17.4-131.7 52.3L200 192 0 192z'
      
    ]
  };

  
    var faRotateBack = faRotateLeft;
  
    var faRotateBackward = faRotateLeft;
  
    var faUndoAlt = faRotateLeft;
  

  
  

  var faSortDown = {
    prefix: 'fass',
    iconName: 'sort-down',
    icon: [
      448,
      512,
      ["sort-desc"],
      'f0dd',
      
      'M8 288L224 520 440 288 8 288z'
      
    ]
  };

  
    var faSortDesc = faSortDown;
  

  
  

  var faSortUp = {
    prefix: 'fass',
    iconName: 'sort-up',
    icon: [
      448,
      512,
      ["sort-asc"],
      'f0de',
      
      'M8 224L224-8 440 224 8 224z'
      
    ]
  };

  
    var faSortAsc = faSortUp;
  

  
  

  var faSquareCheck = {
    prefix: 'fass',
    iconName: 'square-check',
    icon: [
      448,
      512,
      [9745,9989,61510,"check-square"],
      'f14a',
      
      'M448 32l-448 0 0 448 448 0 0-448zM321.1 192.4l-12.7 20.4-80 128-7 11.3-25.3 0-7.2-9.6c-37.6-50.1-58.4-77.9-62.4-83.2l38.4-28.8c7.5 10 21.3 28.4 41.4 55.2 49.1-78.5 73.8-118.1 74.2-118.7l40.7 25.4z'
      
    ]
  };

  
    var faCheckSquare = faSquareCheck;
  

  
  

  var faXmark = {
    prefix: 'fass',
    iconName: 'xmark',
    icon: [
      448,
      512,
      [215,10005,10006,10060,128473,"close","multiply","remove","times"],
      'f00d',
      
      'M86.9 73.4L64.3 50.7 19 96 41.6 118.6 179 256 41.6 393.4 19 416 64.3 461.3 86.9 438.6 224.3 301.3 361.6 438.6 384.3 461.3 429.5 416 406.9 393.4 269.5 256 406.9 118.6 429.5 96 384.3 50.7 361.6 73.4 224.3 210.7 86.9 73.4z'
      
    ]
  };

  
    var faClose = faXmark;
  
    var faMultiply = faXmark;
  
    var faRemove = faXmark;
  
    var faTimes = faXmark;
  

  
  

  var faXmarkLarge = {
    prefix: 'fass',
    iconName: 'xmark-large',
    icon: [
      576,
      512,
      [],
      'e59b',
      
      'M534.9 54.6L557.5 32 512.3-13.3 489.6 9.4 288.3 210.7 86.9 9.4 64.3-13.3 19 32 41.6 54.6 243 256 41.6 457.4 19 480 64.3 525.3 86.9 502.6 288.3 301.3 489.6 502.6 512.3 525.3 557.5 480 333.5 256 534.9 54.6z'
      
    ]
  };

  



export {

  faAngleLeft,
  

  faAngleRight,
  

  faArrowRightArrowLeft,
  
  faExchange,
  

  faCheck,
  

  faChevronDown,
  

  faChevronLeft,
  

  faChevronRight,
  

  faChevronUp,
  

  faChevronsLeft,
  
  faChevronDoubleLeft,
  

  faChevronsRight,
  
  faChevronDoubleRight,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faCircleQuestion,
  
  faQuestionCircle,
  

  faClock,
  
  faClockFour,
  

  faCodeSimple,
  

  faCopy,
  

  faCrosshairs,
  

  faDash,
  
  faMinusLarge,
  

  faImageLandscape,
  
  faLandscape,
  

  faMinus,
  
  faSubtract,
  

  faPlay,
  

  faPlus,
  
  faAdd,
  

  faRectangleList,
  
  faListAlt,
  

  faRotate,
  
  faSyncAlt,
  

  faRotateLeft,
  
  faRotateBack,
  
  faRotateBackward,
  
  faUndoAlt,
  

  faSortDown,
  
  faSortDesc,
  

  faSortUp,
  
  faSortAsc,
  

  faSquareCheck,
  
  faCheckSquare,
  

  faXmark,
  
  faClose,
  
  faMultiply,
  
  faRemove,
  
  faTimes,
  

  faXmarkLarge,
  

};
